var angular = require('angular');
require('./index');



angular.module('listreports.events.console', ['listreports.events'])
    .config([
        '$eventsProvider',

        function($eventsProvider) {
            var superProperties = {};

            var plugin = {
                name: 'Console',

                setSuperProperties: function(properties) {
                    angular.forEach(properties, function(value, key) {
                        superProperties[key] = value;
                    });
                },
                setSuperPropertiesOnce: function(properties) {
                    angular.forEach(properties, function(value, key) {
                        if(!superProperties.hasOwnProperty(key))
                            superProperties[key] = value;
                    });
                },
                track: function(event, properties) {
                    var finalProperties = angular.copy(superProperties);

                    angular.forEach(properties, function(value, key) {
                        finalProperties[key] = value;
                    });

                    console.log('Track:', event, finalProperties);
                }
            };

            $eventsProvider.register(plugin);
        }
    ])
;